import { Subject } from "rxjs";

let sessionEnding = false;

export const authSessionAborted$ = new Subject<void>();

export function markAuthSessionEnding(): void {
	sessionEnding = true;
	authSessionAborted$.next();
}

export function isAuthSessionEnding(): boolean {
	return sessionEnding;
}

export function clearAuthSessionEnding(): void {
	sessionEnding = false;
}
